import {Component} from '@angular/core';
/**
 * \@title Nested menu
 */
export class NestedMenuExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'nested-menu-example',
  templateUrl: 'nested-menu-example.html',
  styleUrls: ['nested-menu-example.css']
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NestedMenuExample_tsickle_Closure_declarations() {
/** @type {?} */
NestedMenuExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NestedMenuExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
